import { Component } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { NavController, LoadingController, Events } from 'ionic-angular';
import { UserData } from '../../providers/user-data';
import { SignupPage } from '../signup/signup';
import { HomePage } from '../home/home'
import { ForgotPasswordPage } from '../forgot-password/forgot-password'
import { ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import * as io from 'socket.io-client';
import { GlobalVariable } from '../../global';
import { ChangePasswordPage } from '../change-password/change-password';
@Component({
  selector: 'page-user',
  templateUrl: 'login.html'
})
export class LoginPage {
  private loginForm: FormGroup;
  socket: any;
  constructor(public navCtrl: NavController, public userData: UserData, private storage: Storage, public events: Events,
    private formBuilder: FormBuilder, private toastCtrl: ToastController, public loadingCtrl: LoadingController) {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }
  ionViewDidLoad() {
    // this.userData.hasLoggedIn().then((result) => {
    //   if(result){
    //     this.navCtrl.setRoot(HomePage)
    //   }
    // });
  }
  onLogin(value) {
    // init wait loader
    let loading = this.loadingCtrl.create({
      content: 'Authenticating...'
    });

    loading.present(); // display loader

    this.userData.login(value).subscribe(
      res => {
        loading.dismiss(); // hide loader
        if (res) {
          this.socket = io.connect(GlobalVariable.BASE_API_URL, {
            'forceNew': false,
          });
          this.socket.removeListener('mentornotify');
          this.socket.on('mentornotify', (val) => {
            console.log(val)
            console.log(this.userData.userid)
            if (Number(val.userid) === Number(this.userData.userid)) {
              this.showNotification(val.msg)
            }
          })
          this.socket.removeListener('approvesadhananotify');
          this.socket.on('approvesadhananotify', (val) => {
            console.log(val)
            console.log(this.userData.userid)
            if (Number(val.userid) === Number(this.userData.userid)) {
              this.showNotification(val.msg)
            }
          })
          if (!res['changepassword']) {
            this.events.publish('menu:toggle');
            this.navCtrl.setRoot(ChangePasswordPage);
          } else {
            this.navCtrl.push(HomePage);
          }
        }
      },
      err => {
        loading.dismiss(); // hide loader
        this.presentToast(err.error.message)
      }
    )
  }

  navigateToForgotPassword() {
    this.navCtrl.push(ForgotPasswordPage)
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      showCloseButton: true
    });
    toast.present();
  }

  showNotification(msg) {
    if (("Notification" in window)) {
      if ((Notification as any).permission === "granted") {
        // If it's okay let's create a notification
        new Notification(msg);
      } else if ((Notification as any).permission !== "denied") {
        Notification.requestPermission().then(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === "granted") {
            new Notification(msg);
          }
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts